import { useState, useCallback } from 'react';

// UseCases
import { toggleGroup } from './tableAccordionUseCase';

/**
 * @typedef useTableAccordionReturn
 * @property {AccordionState} isGroupAccordionOpen - Current accordion state
 * @property {React.Dispatch<React.SetStateAction<AccordionState>>} setIsGroupAccordionOpen - Function to set the accordion state
 * @property {(groupId: string) => void} toggleGroup - Toggle a specific group open/closed
 */

/**
 * Hook to manage the table group accordion state
 * @param {AccordionState} [initialState={}] - Initial accordion state
 * @returns {useTableAccordionReturn} The accordion state and methods
 */
const useTableAccordion = (initialState = {}) => {
  const [isGroupAccordionOpen, setIsGroupAccordionOpen] = useState(initialState);

  /**
   * Toggle a specific group open/closed
   * @param {string} groupId - The group ID
   */
  const toggleGroupHandler = useCallback(
    /** @param {string} groupId */
    (groupId) => {
      setIsGroupAccordionOpen((prev) => toggleGroup(prev, groupId));
    },
    [],
  );

  return {
    isGroupAccordionOpen,
    setIsGroupAccordionOpen,
    toggleGroup: toggleGroupHandler,
  };
};

export default useTableAccordion;
